module.exports = __webpack_public_path__ + "static/media/iphone 12 banner3.70000bd4.jpg";